import React from "react";
import { Mic, MicOff, Volume2, VolumeX, Radio } from "lucide-react";

export type MicState = "idle" | "listening" | "detected" | "waiting";

interface Props {
  state: MicState;
  detectedChord?: string | null;
  volume?: number;
}

export const MicStatusIndicator: React.FC<Props> = ({ state, detectedChord, volume = 0 }) => {
  const config = {
    idle: { icon: <VolumeX className="w-3.5 h-3.5" />, text: "Silencio", color: "bg-[#E8E0D4] text-[#8A8078]" },
    listening: { icon: <Volume2 className="w-3.5 h-3.5 animate-pulse" />, text: "Escuchando...", color: "bg-[#FDE68A] text-[#92400E]" },
    detected: { icon: <Mic className="w-3.5 h-3.5" />, text: detectedChord || "Detectado", color: "bg-[#10B981] text-white" },
    waiting: { icon: <Radio className="w-3.5 h-3.5" />, text: "Esperando compás", color: "bg-[#F5F0E8] text-[#5A524A]" },
  };

  const c = config[state];

  return (
    <div className={`flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider transition-colors ${c.color}`}>
      {c.icon}
      <span>{c.text}</span>
      {state === "listening" && volume > 0.05 && (
        <span className="ml-0.5 w-4 h-1 bg-white/40 rounded-full overflow-hidden">
          <span className="block h-full bg-white rounded-full transition-all" style={{ width: `${Math.min(100, volume * 200)}%` }} />
        </span>
      )}
    </div>
  );
};
